import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { 
  ContainerButtonsOther, 
  ContainerButtonsOne,
  Background, 
  StyledModal, 
  HeaderModal, ContentModal, FooterModal, ButtonConfirmation, Label, ImgBackground} from './style'
import bg_modal_confirmation from '../../assets/images/bg-modal-confirmation.png'

const ModalAlert = ({ noBackgroundBlack, modalUp, title, onClick, confirmModal, confirmSim, confirmNao, message, height= false, topText=false }) => {
  
  return(
    <Background  noBackgroundBlack={noBackgroundBlack} onClick={ onClick }>
      <StyledModal modalUp={modalUp}>
        <HeaderModal message={ title } height={height} topText={topText}>
          <ImgBackground src={bg_modal_confirmation} Alt='Fundo Background' />
        </HeaderModal>
        <ContentModal>
        
          <Label>{ ReactHtmlParser (message) }</Label>
        </ContentModal>
        <FooterModal>
          {
            confirmModal &&
            <ContainerButtonsOther>
              <ButtonConfirmation BackgroundColor='#40bbca' onClick={ confirmSim }>Sim</ButtonConfirmation>
              <ButtonConfirmation BackgroundColor='#40bbca' onClick={ confirmNao }>Não</ButtonConfirmation>
            </ContainerButtonsOther>
          }
          {
            !confirmModal &&
            <ContainerButtonsOne>
              <ButtonConfirmation BackgroundColor='#40bbca' onClick={ onClick }>OK</ButtonConfirmation>
            </ContainerButtonsOne>
          }
          
        </FooterModal>        
      </StyledModal>
    </Background>
  )
}

export default ModalAlert
